export default __webpack_public_path__ + "static/media/SWT1950.34I-41466_-24787_0.3e03751e.jpg";